"use client";

import Card from "../Card/Card";
import type { TCard } from "@/components";
import type { TCardList } from "./card-list.types";

export default function CardList({ numberOfCardsPerRow, cards }: TCardList) {
	if (!cards.length) return;

	return (
		<div
			className={` text-notificationInfo grid grid-cols-1 md:grid-cols-${numberOfCardsPerRow} gap-6`}
		>
			{cards.map((card: TCard) => {
				return <Card key={`card-${card.id}`} card={card} />;
			})}
		</div>
	);
}
